"use strict";
import { useMemo } from "react";
import { ProtocolItems } from "data/tradingApi/__generated__";
import { useV4SwapEnabled } from "features/transactions/swap/hooks/useV4SwapEnabled";
export const DEFAULT_PROTOCOL_OPTIONS = [
  ...[ProtocolItems.V4, ProtocolItems.V3, ProtocolItems.V2]
];
export function useProtocolsForChain(userSelectedProtocols, chainId) {
  const v4SwapAllowed = useV4SwapEnabled(chainId);
  return useMemo(() => {
    let protocols = userSelectedProtocols.filter(
      (protocol) => protocol !== ProtocolItems.UNISWAPX_V2 && protocol !== ProtocolItems.UNISWAPX_V3
    );
    if (!v4SwapAllowed) {
      protocols = protocols.filter((protocol) => protocol !== ProtocolItems.V4);
    }
    return protocols;
  }, [userSelectedProtocols, v4SwapAllowed]);
}
export function useUniswapXPriorityOrderFlag(_chainId) {
  return false;
}
